"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopupConfirm = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const Button_1 = require("../../Button");
const LoadingOverlay_1 = require("../../LoadingOverlay");
const PopupWrapper_1 = require("../PopupWrapper");
const defaultProps = {
    confirmMessage: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/PopupConfirm:message', defaultMessage: 'Please, confirm.' })),
    confirmButtonText: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/PopupConfirm:confirm', defaultMessage: 'Confirm' })),
    closeButtonText: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/PopupConfirm:cancel', defaultMessage: 'Cancel' })),
};
const PopupConfirm = (props) => {
    const { onClose, onConfirm, isOpened, isLoading, isConfirmDisabled, confirmMessage = defaultProps.confirmMessage, closeButtonText = defaultProps.closeButtonText, confirmButtonText = defaultProps.confirmButtonText, modificators, isConfirmRed, children, } = props;
    const className = 'popup';
    return (react_1.default.createElement(PopupWrapper_1.PopupWrapper, { onClose: onClose, isOpened: isOpened, modificators: modificators },
        react_1.default.createElement(LoadingOverlay_1.LoadingOverlay, { isLoading: isLoading },
            react_1.default.createElement("div", { className: `${className}__message` }, confirmMessage),
            children,
            react_1.default.createElement("div", { className: `${className}__buttons` },
                react_1.default.createElement(Button_1.Button, { onClick: onClose, text: closeButtonText, modificators: ['simple'] }),
                react_1.default.createElement(Button_1.Button, { onClick: onConfirm, text: confirmButtonText, modificators: ['simple', isConfirmRed ? 'simple-red' : 'simple-primary'], disabled: isConfirmDisabled })))));
};
exports.PopupConfirm = PopupConfirm;
//# sourceMappingURL=index.js.map